'use strict';

var ipDetectionValidation = function () {
    var deferred = jQuery.Deferred();
	let geolocationByBrowser = typeof desktopGeolocationByBrowser !== 'undefined' && !desktopGeolocationByBrowser  ? !Revealizr.isDesktopDevice : true;
	if (geolocationByBrowser && navigator.geolocation && typeof showStoreBanner !== 'undefined' && showStoreBanner && !TINK.getCookie("geolocation-confirm") && !isInWebview()) {
		navigator.geolocation.getCurrentPosition(function (position) {
			$('body').addClass('in-progress ip-load');
			$('.fancybox-province-selector').remove();
			$.ajax({
				url: "/stores",
				data: {
					latitude: position.coords.latitude,
					longitude: position.coords.longitude
				},
				method: "GET",
				success: function (result) {
					ipDetectionGeolocationDone();
					if (result && result.id) {
						location.reload();
					}
				},
				error: function (jqXHR) {
					ipDetectionGeolocationDone();
					if (!TINK.redirectIfConflict(jqXHR)) {
						$('body').removeClass('in-progress ip-load');
						console.warn("Cannot retrieve store from geolocation [lat=" + position.coords.latitude +
							", long= " + position.coords.longitude + "]")
					}
				}
			});

		}, function (err) {
			ipDetectionGeolocationDone();
			var errorMessages = {1: "PERMISSION_DENIED", 2: "POSITION_UNAVAILABLE", 3: "TIMEOUT"};
			console.warn("Cannot retrieve geolocation code=" + errorMessages[err.code] + ", message=" + err.message);
		}, {
			enableHighAccuracy: true,
			timeout: 5000,
			maximumAge: 0
		});
	}
    return deferred;
};

$(document).ready(function(){
	browserDetectionValidation()
		.then(ipDetectionValidation);

    // On click, close the box
    $('.ipdetection--close').on('click',function(){
        // Add temporary cookie to hide banner for this session
        TINK.setCookie("hide-store-banner", true);
        $('#myStoreLink').off('click');
    });

    $('.ipdetectionFindMyStore').on('click',function(){
        TINK.setCookie("hide-store-banner", true);
    });

    $(".ipdetection--box button.ipdetection--box-yes").click(onClickSetMyStore);

	//flyer store banner
	let $favoriteStorePopup = $('.popover-wrapper-ipdetection');
	if ($favoriteStorePopup.length) {
		$favoriteStorePopup.remodal().open();
	}
});


//Ip detect Favorite Store
function ipdetectmobileClose() {
	$('#ipdetection-mobile [data-tab-close]').trigger('click');
	$('#ipdetection-mobile').removeClass('is_active dishide-is_initialized dishide-target--active dishide-target--inactive');
}

function ipDetectionGeolocationDone() {
	TINK.setCookie("geolocation-confirm", true, 365);
}